import { useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "../mock";

export default function Services() {
  const [active, setActive] = useState(SERVICES[0].id);
  const current = SERVICES.find((s) => s.id === active);

  return (
    <section
      id="services"
      className="relative py-28 md:py-36 bg-gradient-to-b from-[#120127] via-[#190334] to-[#120127] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
             Our Craft
            </div>
            <h2 className="font-display text-5xl md:text-6xl leading-[0.95] max-w-2xl">
              Services built<br />for the <span className="text-jester">obsessed.</span>
            </h2>
          </div>
          <p className="text-white/65 max-w-md text-lg">
            Six refined services. One uncompromising standard. Pick a craft to
            preview the work.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 space-y-2">
            {SERVICES.map((s, i) => (
              <button
                key={s.id}
                onClick={() => setActive(s.id)}
                className={`w-full text-left flex items-center justify-between gap-4 py-5 px-5 rounded-xl border transition-all duration-500 group ${
                  active === s.id
                    ? "bg-jester-purple/20 border-jester"
                    : "bg-white/[0.02] border-white/10 hover:bg-white/[0.04] hover:border-white/20"
                }`}
              >
                <div className="flex items-center gap-5">
                  <span
                    className={`font-stencil text-2xl ${
                      active === s.id ? "text-acid" : "text-white/30"
                    }`}
                  >
                    0{i + 1}
                  </span>
                  <div>
                    <div
                      className={`font-display text-xl tracking-wide ${
                        active === s.id ? "text-white" : "text-white/85"
                      }`}
                    >
                      {s.title}
                    </div>
                    <div className="text-xs text-white/45 mt-1 uppercase tracking-[0.18em] font-label">
                      from {s.from}
                    </div>
                  </div>
                </div>
                <ArrowUpRight
                  className={`w-5 h-5 transition-all duration-500 ${
                    active === s.id
                      ? "text-acid translate-x-0 translate-y-0"
                      : "text-white/30 -translate-x-1 translate-y-1"
                  }`}
                />
              </button>
            ))}
          </div>

          <div className="lg:col-span-7">
            <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-black/40">
              <div key={current.id} className="fade-up">
                <div className="relative h-[360px] md:h-[460px] overflow-hidden">
                  <img
                    src={current.image}
                    alt={current.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#120127] via-[#120127]/50 to-transparent" />
                  <div className="absolute top-5 left-5 px-3 py-1.5 rounded-full bg-acid text-[#120127] text-xs uppercase tracking-[0.2em] font-label font-bold">
                    {current.title}
                  </div>
                </div>
                <div className="p-8">
                  <p className="text-white/85 text-lg leading-relaxed">
                    {current.short}
                  </p>
                  <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                    {current.bullets.map((b, i) => (
                      <li
                        key={i}
                        className="flex items-center gap-2 text-sm text-white/75"
                      >
                        <Check className="w-4 h-4 text-acid" />
                        {b}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-8 flex items-center justify-between border-t border-white/10 pt-6">
                    <div>
                      <div className="flex items-center gap-2">
                        <div className="text-xs uppercase tracking-[0.2em] text-white/40 font-label">
                          Starting at
                        </div>
                        {current.regular && (
                          <span className="px-2 py-0.5 rounded-full bg-acid text-[#120127] text-[9px] uppercase tracking-[0.2em] font-label font-bold">
                            Sale
                          </span>
                        )}
                      </div>
                      <div className="flex items-baseline gap-2">
                        <div className="font-stencil text-3xl text-acid">
                          {current.from}
                        </div>
                        {current.regular && (
                          <div className="font-stencil text-lg text-white/40 line-through decoration-acid/70">
                            {current.regular}
                          </div>
                        )}
                      </div>
                    </div>
                    <a
                      href="#contact"
                      className="flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-white hover:text-acid transition-colors font-label"
                    >
                      Book this service <ArrowUpRight className="w-4 h-4" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
